import { useHistory } from 'react-router';
import { MultiuserTokenService } from '../../lib/multiuserTokenSevise';
import OrdersHttp from '../../Modules/Cart/http';
import OrderActions from 'Modules/Cart/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getCookieDomain } from '../../constants/cookie';
import { URL } from '../../constants/urlMaps';
import { getCartId, getIsCartShared } from '../../Modules/Cart/selectors';
import ShopsHttp from 'Modules/Shops/http';
import { setCurrentShopAction } from '../../Modules/Shops/actions';
import useModalState from './useModalState';
import { checkIsTempUser } from '../../Modules/AAA/selectors';
import { useEffect } from 'react';
import { useCheckMultiuserLink } from './useCheckMultiuserLink';
import AddressActions from '../../Modules/SearchAddress/actions';
import { IPlace } from '../../Modules/Places/types';

type TUseMultiuserInit = () => {
  isMultiUserInitPopupShow: boolean;
  onMultiUserInitPopupClose: () => void;
  initMultiuser: (formAuth?: boolean) => Promise<void>;
  isMultiuserAuthPopupShow: boolean;
  onMultiuserAuthPopupClose: () => void;
  isMultiUserCancelPopupShow: boolean;
  onMultiUserCancelPopupClose: () => void;
  isMultiUserNoCartPopupShow: boolean;
  onMultiUserNoCartPopupClose: () => void;
};

export const useMultiuserInit: TUseMultiuserInit = () => {
  const {
    isVisible: isMultiUserInitPopupShow,
    showModal: showMultiUserInitPopup,
    hideModal: onMultiUserInitPopupClose,
  } = useModalState();
  const {
    isVisible: isMultiuserAuthPopupShow,
    showModal: showMultiuserAuthPopup,
    hideModal: onMultiuserAuthPopupClose,
  } = useModalState();
  const {
    isVisible: isMultiUserCancelPopupShow,
    showModal: showMultiUserCancelPopup,
    hideModal: onMultiUserCancelPopupClose,
  } = useModalState();
  const {
    isVisible: isMultiUserNoCartPopupShow,
    showModal: showMultiUserNoCartPopup,
    hideModal: onMultiUserNoCartPopupClose,
  } = useModalState();
  const history = useHistory();
  const dispatch = useDispatch();
  const cartIdFromStore = useSelector(getCartId);
  const isCartShared = useSelector(getIsCartShared);
  const { isMultiuserLink, tokenFromInvite, cartIdFromInvite } = useCheckMultiuserLink();
  const cartInfoFromStorage = MultiuserTokenService.get();
  const isTempUser = useSelector(checkIsTempUser);

  const setMultiuserCartShop = async (shopId: number) => {
    const data = await ShopsHttp.getShop(shopId);
    dispatch(setCurrentShopAction(data.shop));
  };

  const setMultiuserCartShopAndAdress = async (shopId: number) => {
    const data = await ShopsHttp.getShop(shopId);
    const place = await dispatch(
      AddressActions.updateCurrentAddressFromCoords([data.shop.coordinate.latitude, data.shop.coordinate.longitude])
    );
    // Это нужно чтобы бэк запомнил выбор города и магазина, и при обновлении возвращал их. Иначе будет редирект на SA
    await dispatch(OrderActions.createOrder(shopId, (place as unknown) as IPlace, data.shop.branding));
    dispatch(setCurrentShopAction(data.shop));
  };

  const removeMultiuser = async () => {
    MultiuserTokenService.remove();
    const data = await OrdersHttp.getCart();
    dispatch(OrderActions.setOrder(data.order));
  };

  const initMultiuser = async (formAuth?: boolean) => {
    if (formAuth) {
      try {
        const data = await OrdersHttp.addUserToSharedCart(
          Number(cartInfoFromStorage?.cartId),
          cartInfoFromStorage?.token as string
        );
        dispatch(OrderActions.setOrder(data.order));
        await setMultiuserCartShopAndAdress(data.order.shop_id);
        history.push(URL.catalog);
        showMultiUserInitPopup();
      } catch (e) {
        showMultiUserCancelPopup();
        removeMultiuser();
      }
    } else {
      try {
        const data = await OrdersHttp.addUserToSharedCart(Number(cartIdFromInvite), tokenFromInvite as string);
        dispatch(OrderActions.setOrder(data.order));
        MultiuserTokenService.set(
          { token: tokenFromInvite as string, cartId: Number(cartIdFromInvite) },
          getCookieDomain().domain
        );
        await setMultiuserCartShop(data.order.shop_id);
        history.push(URL.catalog);
        showMultiUserInitPopup();
      } catch (e) {
        showMultiUserCancelPopup();
        removeMultiuser();
      }
    }
  };

  const startMultiuser = async () => {
    if (isTempUser) {
      MultiuserTokenService.set(
        { token: tokenFromInvite as string, cartId: Number(cartIdFromInvite) },
        getCookieDomain().domain
      );
      showMultiuserAuthPopup();
    } else {
      initMultiuser();
    }
  };

  useEffect(() => {
    const init = async () => {
      if (isMultiuserLink) {
        if (Number(cartIdFromInvite) !== Number(cartIdFromStore) && !isCartShared) {
          startMultiuser();
        }
      } else {
        if (
          cartInfoFromStorage?.cartId &&
          cartIdFromStore &&
          Number(cartIdFromStore) !== Number(cartInfoFromStorage?.cartId)
        )
          try {
            await dispatch(OrderActions.setSharedCard(cartInfoFromStorage?.cartId));
          } catch (e) {
            showMultiUserNoCartPopup();
            await removeMultiuser();
          }
      }
    };
    init();

    // eslint-disable-next-line
  }, [cartIdFromInvite, cartIdFromStore, cartInfoFromStorage?.cartId, isCartShared, tokenFromInvite, isTempUser]);

  return {
    isMultiUserInitPopupShow,
    onMultiUserInitPopupClose,
    initMultiuser,
    isMultiuserAuthPopupShow,
    onMultiuserAuthPopupClose,
    isMultiUserCancelPopupShow,
    onMultiUserCancelPopupClose,
    isMultiUserNoCartPopupShow,
    onMultiUserNoCartPopupClose,
  };
};
